module.exports = "/assets/data/6fb0e6b52a535628cd0283afefb7e4ff-CV47.data.json";